/** @format */

import axios from "axios";
import { BASEURL } from "../Utils";
const apiRequests = {};
const axiosInterceptorInstance = axios.create({
    baseURL: BASEURL, // Replace with your API base URL
});

// Request interceptor
axiosInterceptorInstance.interceptors.request.use(
    async (config) => {


        if (config.headers) {
            config.headers.setAuthorization(`Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2RhcmtyZWQtZm94LTMzNDc5MC5ob3N0aW5nZXJzaXRlLmNvbSIsImlhdCI6MTczMzkyOTQ1NSwibmJmIjoxNzMzOTI5NDU1LCJleHAiOjE3MzM5MzAwNTUsImRhdGEiOnsidXNlciI6eyJpZCI6MSwiZGV2aWNlIjoiIiwicGFzcyI6IjU0YjUzMGI0ODg1ZDFmMzI3MDFhMjU0ZjA4ZDJjYTNlIn19fQ.94ETB4g8paULwCitDsFq2ak9srP1V7ZM7VMOHe0RCuo`);
        }

        const requestKey = `${config.method}-${config.url}`;

        // Check if there's a previous request with the same key
        if (apiRequests[requestKey]) {
            // Abort the previous request
            apiRequests[requestKey].abort();
        }

        // Create a new AbortController for the current request
        const controller = new AbortController();
        config.signal = controller.signal;
        apiRequests[requestKey] = controller;

        return config;
    },
    (error) => {
        // Handle request errors here

        return Promise.reject(error);
    }
);
// End of Request interceptor

// Response interceptor
axiosInterceptorInstance.interceptors.response.use(
    (response) => {
        // Modify the response data here
        const requestKey = `${response.config.method}-${response.config.url}`;

        // Clean up completed request
        delete apiRequests[requestKey];

        return response;
    },
    (error) => {
        if (error.code === "ERR_CANCELED") {
        } else {
            // Handle other errors
        }
        // here you could check expired token and refresh it if necessary

        return Promise.reject(error);
    }
);
// End of Response interceptor

export default axiosInterceptorInstance;
